<template>
  <PageRegister/>
</template>

<script>
import AppRouteMixin from '~/mixins/AppRouteMixin'
import LoggedOutUserRestrictedRouteMixin from '~/mixins/LoggedOutUserRestrictedRouteMixin'
import PageRegister from '@theme/components/user/PageRegister'

const PAGE = {
  name: 'RouteRegister',
  nuxtI18n: {
    paths: {
      cs: '/registrovat',
      de: '/jetzt-registrieren',
      en: '/register',
      sk: '/registrovat',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageRegister,
  },
  mixins: [AppRouteMixin, LoggedOutUserRestrictedRouteMixin],
  async asyncData({ store }) {
    store.commit('locale/SET_CANONICALS')
  },
}
export default PAGE
</script>
